import { render, staticRenderFns } from "./PrivacyPolicyPt.vue?vue&type=template&id=0ae14798&scoped=true"
import script from "./PrivacyPolicyPt.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae14798",
  null
  
)

export default component.exports